import * as React from "react";
import * as ReactDOM from 'react-dom';
import { Main } from './main';
import '@amzn/awsui-global-styles/polaris.css';
import './index.scss';
ReactDOM.render(<Main />, document.getElementById('cript-ui'));